// G.AI answers can carry markdown emphasis; report text the user saves (the GHG performance
// commentary, the SECR narratives) is plain text.
export const toPlainCommentary = (text: string): string => text.replace(/\*\*([^*]+)\*\*/g, '$1').trim();
